// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ===== Selected Branch Header — خطوط ومسافات موحّدة ===== */
.branch-header {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: start;
  gap: 0 0.9rem;
  max-width: 100%;
  margin: 0.2rem 0.25rem;
  padding: 8px 8px;
  border: 1px solid #36a3f7;
  border-radius: 12px;
  background: #fff;
  font-family: "Cairo", sans-serif;
  font-size: 14px; /* البقية 14px */
  box-sizing: border-box;
}

@media (max-width: 576px) {
  .branch-header {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .branch-header__logo {
    order: -1;
  }
}
.branch-header__side {
  min-width: 0;
}

.branch-header__side--ar {
  text-align: right;
  direction: rtl;
}

.branch-header__side--en {
  text-align: left;
}

.branch-header__title {
  margin: 0 0 0.125rem 0;
  font-size: 18px; /* اسم الشركة */
  font-weight: 700;
  line-height: 1.3;
  color: #575962;
  max-width: 30ch;
  word-wrap: break-word;
}

.branch-header__branch-name {
  margin: 0 0 0.25rem 0;
  font-size: 16px; /* اسم الفرع */
  font-weight: 600;
  line-height: 1.3;
  color: #6c757d;
}

.branch-header__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.branch-header__item {
  margin: 0.125rem 0;
  font-size: 14px; /* البقية: هاتف، إيميل، العنوان */
  font-weight: 500;
  line-height: 1.35;
  color: #575962;
}

.branch-header__label {
  font-weight: 600;
  color: #3f4254;
}

.branch-header__logo {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0.5rem 0 0.2rem;
  min-height: 0;
}

/* تناسب الصورة مع حجم الشعار الأكبر دون تغيير توازن المخطط */
.branch-header__logo-img {
  height: 5.75rem; /* أكبر قليلاً ليكون أكثر وضوحاً */
  width: auto;
  max-width: 7rem;
  max-height: 6rem;
  object-fit: contain;
  object-position: center;
  border-radius: 8px;
}

/* الطباعة: الحفاظ على المظهر — إجبار 3 أعمدة (عربي | شعار | إنجليزي) */
@media print {
  .branch-header {
    display: grid !important;
    grid-template-columns: 1fr auto 1fr !important;
    gap: 0 0.9rem !important;
    margin: 0.25rem 0;
    padding: 10px 12px;
    border-radius: 10px;
  }
  .branch-header__logo {
    order: unset !important;
  }
  .branch-header__title {
    font-size: 18px;
  }
  .branch-header__branch-name {
    font-size: 16px;
  }
  .branch-header__item {
    font-size: 14px;
  }
  .branch-header__logo-img {
    height: 5.75rem;
    max-width: 7rem;
    max-height: 6rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/selected-branch-header/selected-branch-header.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,6DAAA;AAEA;EACE,aAAA;EACA,mCAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA,EAAA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE;IACE,0BAAA;IACA,SAAA;EACF;EACA;IACE,SAAA;EACF;AACF;AAEA;EACE,YAAA;AAAF;;AAGA;EACE,iBAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,sBAAA;EACA,eAAA,EAAA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AAAF;;AAGA;EACE,qBAAA;EACA,eAAA,EAAA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,eAAA,EAAA,iCAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,wBAAA;EACA,aAAA;AAAF;;AAGA,6DAAA;AACA;EACE,eAAA,EAAA,kCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAAF;;AAGA,uEAAA;AACA;EACE;IACE,wBAAA;IACA,8CAAA;IACA,wBAAA;IACA,iBAAA;IACA,kBAAA;IACA,mBAAA;EAAF;EAGA;IACE,uBAAA;EADF;EAGA;IACE,eAAA;EADF;EAGA;IACE,eAAA;EADF;EAGA;IACE,eAAA;EADF;EAGA;IACE,eAAA;IACA,eAAA;IACA,gBAAA;EADF;AACF","sourcesContent":["/* ===== Selected Branch Header — خطوط ومسافات موحّدة ===== */\n\n.branch-header {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: start;\n  gap: 0 0.9rem;\n  max-width: 100%;\n  margin: 0.2rem 0.25rem;\n  padding: 8px 8px;\n  border: 1px solid #36a3f7;\n  border-radius: 12px;\n  background: #fff;\n  font-family: 'Cairo', sans-serif;\n  font-size: 14px; /* البقية 14px */\n  box-sizing: border-box;\n}\n\n@media (max-width: 576px) {\n  .branch-header {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  .branch-header__logo {\n    order: -1;\n  }\n}\n\n.branch-header__side {\n  min-width: 0;\n}\n\n.branch-header__side--ar {\n  text-align: right;\n  direction: rtl;\n}\n\n.branch-header__side--en {\n  text-align: left;\n}\n\n.branch-header__title {\n  margin: 0 0 0.125rem 0;\n  font-size: 18px; /* اسم الشركة */\n  font-weight: 700;\n  line-height: 1.3;\n  color: #575962;\n  max-width: 30ch;\n  word-wrap: break-word;\n}\n\n.branch-header__branch-name {\n  margin: 0 0 0.25rem 0;\n  font-size: 16px; /* اسم الفرع */\n  font-weight: 600;\n  line-height: 1.3;\n  color: #6c757d;\n}\n\n.branch-header__list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.branch-header__item {\n  margin: 0.125rem 0;\n  font-size: 14px; /* البقية: هاتف، إيميل، العنوان */\n  font-weight: 500;\n  line-height: 1.35;\n  color: #575962;\n}\n\n.branch-header__label {\n  font-weight: 600;\n  color: #3f4254;\n}\n\n.branch-header__logo {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding: 0.5rem 0 0.2rem;\n  min-height: 0;\n}\n\n/* تناسب الصورة مع حجم الشعار الأكبر دون تغيير توازن المخطط */\n.branch-header__logo-img {\n  height: 5.75rem;   /* أكبر قليلاً ليكون أكثر وضوحاً */\n  width: auto;\n  max-width: 7rem;\n  max-height: 6rem;\n  object-fit: contain;\n  object-position: center;\n  border-radius: 8px;\n}\n\n/* الطباعة: الحفاظ على المظهر — إجبار 3 أعمدة (عربي | شعار | إنجليزي) */\n@media print {\n  .branch-header {\n    display: grid !important;\n    grid-template-columns: 1fr auto 1fr !important;\n    gap: 0 0.9rem !important;\n    margin: 0.25rem 0;\n    padding: 10px 12px;\n    border-radius: 10px;\n  }\n\n  .branch-header__logo {\n    order: unset !important;\n  }\n  .branch-header__title {\n    font-size: 18px;\n  }\n  .branch-header__branch-name {\n    font-size: 16px;\n  }\n  .branch-header__item {\n    font-size: 14px;\n  }\n  .branch-header__logo-img {\n    height: 5.75rem;\n    max-width: 7rem;\n    max-height: 6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
